module.exports = __webpack_public_path__ + "img/score_1.09aa6574.png";